import script from "./scoreDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./scoreDialog.vue?vue&type=script&setup=true&lang=js"

import "./scoreDialog.vue?vue&type=style&index=0&id=58ac08ed&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ac08ed"]])

export default __exports__